
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notification-settings",
      function () {
        return require("private-next-pages/notification-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notification-settings"])
      });
    }
  